export default {
    'created': 'Aangemaakt',
    'sorting': 'Aan het sorteren',
    'check-stock': 'Voorraad controleren',
    'waiting-for-goods-receipt': 'Wachten op Goederenontvangst',
    'unable-to-ship-all': 'Kan niet verzenden (gehele batch)',
    'received': 'Ontvangen',
    'closed': 'Gesloten',
    'shipped': 'Verzonden',
}
